<cache-date></cache-date>

<period></period>

<filterForm [addFilterParams]="filter.addFilterParams"></filterForm>

<br>

<div class="row">
	<div class="col-md-12">
		<div class="btn-group" role="group">
			<button
				*ngFor="let v of ['absolute', 'relative']"
				type="button"
				[ngClass]="[
					'btn',
					'btn-default',
					v == chartGroupType ? 'active' : ''
				]"
				(click)="chartGroupType=v"
				[attr.data-sectionvalue]="v">
				{{ v }}
			</button>
		</div>
		
		<chart [data]="buyingChart.data | chartSwitchData:chartGroupType" [options]="buyingChart.options" (onFilterChange)="updateData($event, 'buyingChart')" [sextant]="'buy-chart'"></chart>
		
		<ngb-accordion #acc="ngbAccordion">
			<ngb-panel title="Описание" [id]="'buyingChartDesc'">
				<ng-template ngbPanelContent>
					Статус домена берётся из user_domains из монги.
					
					
					
					
					
					<ul>
						<li>
							<strong>Active</strong> - активный ведущий на юкит домен
						</li>
						
						<li>
							<strong>Expired</strong> – домен деактивирован, т.е., он всё ещё числится за клиентом, но расплата за его продление НЕ наступила. этот статус предшествует статусу free, длится 30+ дней в RU зоне, но мы ставим 29 "чтобы никто не догадался".
						</li>
						
						<li>
							<strong>Free</strong> – статус, получаемый "автоматически" когда по нашим собственным представлениям домен удаляется у регистратора. На самом деле домен может быть ещё не удалён, он может быть вполне ещё даже доступен по whois и т.п., но мы уже ничего не можем с ним сделать, и это вот такой вот статус. Получается он автоматикой, если клиент ничего не делает со своим купленным доменом.
						</li>
						
						<li>
							<strong>Renew</strong> – домен был продлён. Т.е., он был когда-то куплен или был трансфернут в юкит, а потом клиент оплатил его продление. что означают надписи в легенде для этого статуса я пока понять не в силах.
						</li>
						
						<li>
							<strong>Removed</strong> – клиент когда-то покупал домен, и, когда он перешёл в статус expired он не стал его продлевать, а нажал кнопку удалить, т.е. – стёр его самостоятельно. так предполагалось отличать тех, кто просто забыл, от тех кто не забыл и что-то предпринял
						</li>
					</ul>
				</ng-template>
			</ngb-panel>
		</ngb-accordion>
		<hr/>
	</div>
	
	<div class="col-md-12">
		<div class="form-check">
			<input class="form-check-input" type="checkbox" [disabled]="this.attachChart.isLoader" [(ngModel)]="attachChartExcludeFreeZones" id="excludeFreeZonesCheck" (change)="excludeFreeZonesCheckChange()">
			<label class="form-check-label" for="excludeFreeZonesCheck">{{ 'adminstat.filterForm.excludeFreeZones' | translate }}</label>
		</div>
		<chart [data]="attachChart.data" [options]="attachChart.options" (onFilterChange)="updateData($event, 'attachChart')" [sextant]="'attach-chart'"></chart>
		
		<hr/>
		
		<button
			*ngFor="let v of ['absolute', 'relative']"
			type="button"
			[ngClass]="[
					'btn',
					'btn-default',
					v == chartGroupType ? 'active' : ''
				]"
			(click)="chartGroupType=v"
			[attr.data-sectionvalue]="v">
			{{ v }}
		</button>
		<chart [data]="realAliveChart.data | chartSwitchData:chartGroupType" [options]="realAliveChart.options" (onFilterChange)="updateData($event, 'realAliveChart')" [sextant]="'real-alive-chart'"></chart>
		
		
		<ngb-accordion #acc="ngbAccordion">
			<ngb-panel title="Описание" [id]="'desc'">
				<ng-template ngbPanelContent>
					<ul>
						<li>
							Обслуживаемые домены - кол-во доменов, которые были валидные на начало месяца
						</li>
						
						<li>
							Реально живые "чистые" домены - кол-во доменов, которые были валидные на начало месяца и на текущий момент прикреплены к нашим сайтам
						</li>
					</ul>
				</ng-template>
			</ngb-panel>
		</ngb-accordion>
		
		<hr/>
	</div>
	
	<div class="col-md-12">
		<chart [data]="sslChart.data" [options]="sslChart.options" (onFilterChange)="updateData($event, 'sslChart')" [sextant]="'ssl-chart'"></chart>
		
		<hr/>
	</div>
	
	<div class="col-md-12">
		<div class="btn-group" role="group">
			<button
				*ngFor="let v of ['absolute', 'relative']"
				type="button"
				[ngClass]="[
					'btn',
					'btn-default',
					v == chartGroupType ? 'active' : ''
				]"
				(click)="chartGroupType=v"
				[attr.data-sectionvalue]="v">
				{{ v }}
			</button>
		</div>
		<chart [data]="departedChart.data | chartSwitchData:chartGroupType" [options]="departedChart.options" (onFilterChange)="updateData($event, 'departedChart')" [sextant]="'departed-chart'"></chart>
		
		<hr/>
	</div>
	
	<div class="col-md-12">
		<ngb-accordion #acc="ngbAccordion">
			<ngb-panel title="{{ 'adminstat.billing.expired_domains.' + tableType + ' domains' | translate }}" [id]="'total'">
				<ng-template ngbPanelContent>
					<div class="btn-group" role="group">
						<button
							*ngFor="let _value of ['departed', 'comeback']"
							type="button"
							[ngClass]="[
								'btn',
								'btn-default',
								_value == tableType ? 'active' : ''
							]"
							[attr.value]="_value"
							(click)="tableType=$event.target.value">
							{{ 'adminstat.billing.expired_domains.' + _value + ' domains' | translate }}
						</button>
					</div>
					
					<br>
					
					<table class="table">
						<thead>
							<th>
								{{ 'adminstat.billing.expired_domains.' + (tableType == "departed" ? 'depart to' : 'comeback from') | translate }}
							</th>
							
							<th>
								{{ 'adminstat.billing.expired_domains.absolute count' | translate }}
							</th>
							
							<th>
								{{ 'adminstat.billing.expired_domains.relative count' |  translate }} (%)
							</th>
						</thead>
						
						<tr *ngFor="let stat of departedTable[tableType]">
							<td>
								<button type="button" class="btn btn-link" (click)="showDepartedTableDetail(stat)">{{ stat.moveTo }}</button>
							</td>
							
							<td>
								{{ stat.count }}
							</td>
							
							<td>
								{{ (stat.count / departedTable[tableType + 'Total'] * 100).toFixed(2) }}
							</td>
						</tr>
					</table>
				</ng-template>
			</ngb-panel>
		</ngb-accordion>
	</div>
</div>
